import { IconButton, IconUserOutline } from '@zillow/constellation';
import React from 'react';
export const QuickContact = () => {
  return (
    <>
      <IconButton icon={<IconUserOutline />} title={'Contact Status'} bare size={'sm'}></IconButton>
    </>
  );
};
